import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import warehouse from '../assets/images/warehouse-bags.jpg';
import sign from '../assets/images/facility-sign.jpg';
import granules from '../assets/images/granules.jpg';
import './Facility.css';

export default function Facility() {
  const { t } = useLanguage();

  return (
    <section id="facility" className="section section--alt facility">
      <div className="container">
        <div className="section-head section-head--center">
          <span className="kicker">{t.facility.kicker}</span>
          <h2 className="section-title">{t.facility.title}</h2>
          <p className="facility__desc">{t.facility.desc}</p>
        </div>
        <div className="facility__gallery">
          <div className="facility__item facility__item--tall">
            <img src={warehouse} alt="Alhilal First warehouse with packed 25kg bags" loading="lazy" />
          </div>
          <div className="facility__item">
            <img src={sign} alt="Alhilal First facility entrance sign at dusk" loading="lazy" />
          </div>
          <div className="facility__item">
            <img src={granules} alt="Calcium carbonate masterbatch granules close-up" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}
